// 页内凭证灯箱：admin/agent/customer/merchant 四端实现逐字 diff 一致（md5 相同）后逐字搬运
// 至此单一真源（FE2-016）；各端本地文件改为 re-export 壳，行为零变化。
import { useEffect } from 'react';
import { X } from 'lucide-react';

/** 页内灯箱：仅图片 + 关闭。blob URL 由调用方在 unmount 时 revoke。 */
export function CredentialLightbox({
  open,
  src,
  alt,
  closeLabel = '关闭',
  onClose,
}: {
  open: boolean;
  src: string | null;
  alt?: string;
  closeLabel?: string;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!open) {
      return;
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open || !src) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-slate-900/70" onClick={onClose} />
      <button
        type="button"
        className="absolute top-4 right-4 z-10 rounded-full bg-white/90 p-2 text-slate-700 hover:bg-white cursor-pointer"
        onClick={onClose}
        aria-label={closeLabel}
      >
        <X className="w-5 h-5" />
      </button>
      <img
        src={src}
        alt={alt || '凭证影像'}
        className="relative z-[1] max-h-[90vh] max-w-[92vw] object-contain rounded-lg shadow-pop"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}

export default CredentialLightbox;
